import React from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';

import LinkItem from './link-item';
import {CustomBreadcrumbsProps} from './types';
import {useTheme} from '@mui/material';

export default function CustomBreadcrumbs({
  links,
  action,
  heading,
  moreLink,
  activeLast,
  sx,
  ...other
}: CustomBreadcrumbsProps) {
  const theme = useTheme();
  const lastLink = links && links[links.length - 1]?.name;
  // const firstLink = links?.[0]?.name;

  const handleClick = () => {
    if (links && links.length > 0 && links[0].href) {
      if (links[0].onClick) {
        links[0].onClick();
      }
    }
  };

  return (
    <Box sx={{...sx}}>
      <Stack direction="row" alignItems="center">
        <Box sx={{flexGrow: 1}}>
          {/* HEADING */}
          {!!heading && (
            <Typography
              variant="h4"
              gutterBottom
              color={theme.palette.primary.lighter}>
              {heading}
            </Typography>
          )}

          {/* BREADCRUMBS */}
          {links && !!links.length && (
            <Breadcrumbs
              separator={<Separator />}
              {...other}
              onClick={handleClick}>
              {links.map((link, index) => (
                <LinkItem
                  key={link?.name || ''}
                  link={link}
                  activeLast={activeLast && index === links.length - 1}
                  disabled={links.length !== 1 && link?.name === lastLink}
                  // sx={
                  //   link?.name === firstLink
                  //     ? {
                  //         fontWeight: '600 !important',
                  //         fontSize: '1.1rem !important'
                  //       }
                  //     : {}
                  // }
                />
              ))}
            </Breadcrumbs>
          )}
        </Box>

        {action && <Box sx={{flexShrink: 0}}> {action} </Box>}
      </Stack>

      {/* MORE LINK */}
      {!!moreLink && (
        <Box sx={{mt: 2}}>
          {moreLink.map((href, index) => (
            <Link
              key={index}
              href={href}
              variant="body2"
              target="_blank"
              rel="noopener"
              sx={{display: 'table'}}>
              {href}
            </Link>
          ))}
        </Box>
      )}
    </Box>
  );
}

function Separator() {
  return (
    <Box
      component="span"
      sx={{
        width: 4,
        height: 4,
        borderRadius: '50%',
        bgcolor: 'text.disabled'
      }}
    />
  );
}
